/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Attribute { 
    name?: string;
    type?: Attribute.TypeEnum;
    multiValued?: boolean;
    required?: boolean;
    caseExact?: boolean;
    mutability?: Attribute.MutabilityEnum;
    returned?: Attribute.ReturnedEnum;
    uniqueness?: Attribute.UniquenessEnum;
    referenceTypes?: Array<string>;
    canonicalValues?: Set<string>;
    description?: string;
    subAttributes?: Array<Attribute>;
}
export namespace Attribute {
    export type TypeEnum = 'binary' | 'boolean' | 'complex' | 'dateTime' | 'decimal' | 'integer' | 'reference' | 'string';
    export const TypeEnum = {
        Binary: 'binary' as TypeEnum,
        Boolean: 'boolean' as TypeEnum,
        Complex: 'complex' as TypeEnum,
        DateTime: 'dateTime' as TypeEnum,
        Decimal: 'decimal' as TypeEnum,
        Integer: 'integer' as TypeEnum,
        Reference: 'reference' as TypeEnum,
        String: 'string' as TypeEnum
    };
    export type MutabilityEnum = 'immutable' | 'readOnly' | 'readWrite' | 'writeOnly';
    export const MutabilityEnum = {
        Immutable: 'immutable' as MutabilityEnum,
        ReadOnly: 'readOnly' as MutabilityEnum,
        ReadWrite: 'readWrite' as MutabilityEnum,
        WriteOnly: 'writeOnly' as MutabilityEnum
    };
    export type ReturnedEnum = 'always' | 'default' | 'never' | 'request';
    export const ReturnedEnum = {
        Always: 'always' as ReturnedEnum,
        Default: 'default' as ReturnedEnum,
        Never: 'never' as ReturnedEnum,
        Request: 'request' as ReturnedEnum
    };
    export type UniquenessEnum = 'global' | 'none' | 'server';
    export const UniquenessEnum = {
        Global: 'global' as UniquenessEnum,
        None: 'none' as UniquenessEnum,
        Server: 'server' as UniquenessEnum
    };
}


